module.exports = __webpack_public_path__ + "static/media/postgresql.1a0972c8.svg";